import { CSSProperties } from 'react';

import { Progress } from '@/components/ui/progress';

interface ProgressBarProps {
  value: number;
  barColor?: CSSProperties['backgroundColor'];
  trackColor?: CSSProperties['backgroundColor'];
  showLabel?: boolean;
  label?: React.ReactNode;
  /**
   * Accessible name for the underlying progressbar. Falls back to `label`
   * when it is a plain string; otherwise the primitive derives a name from
   * the value.
   */
  ariaLabel?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  barColor = 'var(--success)',
  trackColor = 'var(--surface-tertiary)',
  showLabel = true,
  label,
  ariaLabel,
}) => {
  const resolvedAriaLabel =
    ariaLabel ?? (typeof label === 'string' ? label : undefined);

  return (
    <div className="progress-bar">
      <Progress
        value={value}
        // Keep the legacy `progress-bar_container` hook class so contextual
        // SCSS overrides (width/background per feature) keep applying. The
        // height/radius overrides win via twMerge over the primitive defaults.
        className="progress-bar_container h-1 rounded-xs"
        indicatorClassName="min-w-[0.25rem] rounded-xs"
        style={{ backgroundColor: trackColor }}
        indicatorStyle={{ backgroundColor: barColor }}
        aria-label={resolvedAriaLabel}
      />
      {showLabel && (
        <div className="progress-bar_label">
          {label ?? Math.round(value) + '%'}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
